import { CATEGORY_LABELS, OVERDUE_HOURS, PRIORITY_CONFIG } from "./constants";

export function CategoryPill({ category }: { category: string }) {
  const label = CATEGORY_LABELS[category] ?? category;
  return (
    <span className="inline-flex whitespace-nowrap items-center rounded-full bg-[#ece8e1] px-3 py-1 text-sm text-[#58534c]">
      {label}
    </span>
  );
}

export function StatusPill({
  status,
  resolutionReason,
}: {
  status: string;
  resolutionReason?: string | null;
}) {
  if (status === "CLOSED" && resolutionReason === "expired") {
    return (
      <span className="inline-flex items-center rounded-md px-3 py-1 text-sm font-medium bg-zinc-300 text-zinc-600">
        Expired
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center rounded-md px-3 py-1 text-sm font-medium text-white ${
        status === "OPEN" ? "bg-[#7bbe6a]" : "bg-gray-400"
      }`}
    >
      {status === "OPEN" ? "Open" : "Closed"}
    </span>
  );
}

export function PriorityPill({ priority }: { priority: string }) {
  const config = PRIORITY_CONFIG[priority] ?? PRIORITY_CONFIG.STANDARD;
  return (
    <span
      className={`inline-flex whitespace-nowrap items-center rounded-full px-3 py-1 text-sm font-medium ${config.pillBg} ${config.pillText}`}
    >
      {config.label}
    </span>
  );
}

export function OverdueBadge() {
  return (
    <span className="inline-flex items-center rounded-md bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700">
      Overdue
    </span>
  );
}

export function isOverdue(
  createdAt: string,
  priority: string,
  status: string,
): boolean {
  if (status !== "OPEN") return false;
  const hours = OVERDUE_HOURS[priority];
  if (!hours) return false;
  const age = Date.now() - new Date(createdAt).getTime();
  return age > hours * 60 * 60 * 1000;
}
